<template>
  <div class="qrcode-app-tip" v-observer="{ show: handleStat }">
    <img
      :src="qrcode" width="120" height="120"
      alt=""
    >
    <h5>扫描安装手机、iPad端</h5>
    <p>享受随时随地躺着看视频</p>
  </div>
</template>

<script>
export default {
  props: {
    from: {
      type: String,
      default: 'top_action_bar',
    },
  },
  data () {
    return {
      qrcode: require('@remote/assets/images/web/qrcode.png'),
    }
  },
  methods: {
    handleStat () {
      this.$stat('pc_yunpan_share', 'download_app_qrcode_show', { from: this.from })
    },
  },
}
</script>

<style lang="scss">
.qrcode-app-tip {
  position: absolute;
  width: 140PX;
  padding: 12PX;
  background: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6PX;
  text-align: center;
  display: none;
  z-index: 100;
  line-height: 16PX;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  h5 {
    font-size: 13PX;
    color: #1A1A1A;
    font-weight: 600;
    margin-top: 10PX;
  }
  p {
    font-size: 12PX;
    margin-top: 4PX;
    color: var(--color-default);
  }
}
</style>
